import React, { useEffect, useState } from 'react'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import { saveAuthToken } from '../api/auth'
import './RegisterPage.css'

export function AuthCallbackPage() {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const [message, setMessage] = useState('Signing you in…')

  useEffect(() => {
    const token = searchParams.get('token')
    const error = searchParams.get('error')

    if (token) {
      saveAuthToken(token)
      const needsUsername = searchParams.get('needs_username') === '1'
      navigate(needsUsername ? '/register/google-username' : '/', { replace: true })
      return
    }

    if (error === 'access_denied') {
      setMessage('Google sign-in was cancelled.')
      return
    }

    const friendly =
      error === 'missing_code'
        ? 'Google sign-in did not complete. Please try again.'
        : error?.includes('email already exists')
          ? error
          : error || 'Google sign-in failed. Please try again.'
    setMessage(friendly)
  }, [searchParams, navigate])

  return (
    <div className="register-root">
      <div className="register-grain" aria-hidden="true" />
      <div className="register-page">
        <main className="register-hero">
          <p className="register-description">{message}</p>
          <div className="register-area">
            <Link to="/login" className="register-btn">
              Back to login
            </Link>
          </div>
        </main>
      </div>
    </div>
  )
}
